import { Provider } from '@angular/core';

import { GetGuardShiftDetails } from '../Domain/Port/GetGuardShiftDetails/get-guard-shift.details';
import { BackendGetGuardShiftDetailsService } from '../Infrastructure/Adapter/GetGuardShiftDetails/backend-get-guard-shift-details.service';

export const provideGetGuardShiftDetails = (): Provider[] => {
    return [
        {
            provide: GetGuardShiftDetails,
            useExisting: BackendGetGuardShiftDetailsService
        }
    ];
};
